import { CircularProgress, Container } from '@material-ui/core';
import { useEffect } from "react";

export function Redirect({ url, delayMs = 1500 }) {
  
  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.href = url
    }, delayMs)

    return () => {
      clearTimeout(timeout)
    }
  }, [url, delayMs])
  return (
    <>
      <Container>
        <CircularProgress size={60} style={{ 'color': '#0587FF' }} />
        <h1 style={{ marginBottom: "50px", marginTop: "50px" }}>Você será redirecionado para a página da transportadora</h1>
      </Container>
    </>
  )
}
